var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuExpenses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4.57142H0V11.25C0 11.7333 0.191899 12.1965 0.533696 12.5377C0.874942 12.8795 1.33818 13.0714 1.82143 13.0714H15.1786C15.6619 13.0714 16.1251 12.8795 16.4663 12.5377C16.8081 12.1965 17 11.7332 17 11.25V4.57142ZM2.42857 10.6428H6.67857C7.01372 10.6428 7.28571 10.3709 7.28571 10.0357C7.28571 9.70055 7.01372 9.42856 6.67857 9.42856H2.42857C2.09342 9.42856 1.82143 9.70055 1.82143 10.0357C1.82143 10.3709 2.09342 10.6428 2.42857 10.6428ZM0 3.35713H17V2.74999C17 2.2667 16.8081 1.8035 16.4663 1.46225C16.1251 1.12046 15.6618 0.928558 15.1786 0.928558H1.82143C1.33814 0.928558 0.874945 1.12046 0.533696 1.46225C0.191906 1.8035 0 2.26674 0 2.74999V3.35713Z",
    fill: "#141320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuExpenses);
export default __webpack_public_path__ + "static/media/menu-expenses.a33a8682d59bcca9c9fde865f469e6ea.svg";
export { ForwardRef as ReactComponent };